// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconShare = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M7 6.5v2.75l4-4V14h2V5.25l4 4V6.5l-5-5z" />,
    <path d="M6 10v10h12V10h2v12H4V10z" />
  );
export default SvgIconShare;
